import React from "react";

const Gre = () => {
  return <div>Gre</div>;
};

export default Gre;
